export default __webpack_public_path__ + "static/media/1300.c0b51f84.png";